<div class="mb-3" [hidden]="!shippingDateOptions?.length">
  <label>{{ label }}</label>
  <select class="form-control" [ngClass]="{'border-danger': !selectedDate}" [(ngModel)]="selectedDate" (change)="dateSelected.next(selectedDate)" [disabled]="readonly">
    <option value="">{{"MAKE_A_CHOICE"|translate}}</option>
    @for (option of shippingDateOptions; track option) {
      <option [value]="option.id" innerHTML="{{ _moment(option.date).format('DD-MM-YYYY') }} ({{ _moment(option.date).format('dddd').toUpperCase()|translate }}) - {{option.shipping_costs.value | currencyConvert: option.shipping_costs.currency}}"></option>
    }
  </select>
</div>
